import { config } from "../config";

const queryParams = new URLSearchParams(location.search);
const xolaUriParam = queryParams.get("xolaUri");

export const xolaUri = xolaUriParam ? xolaUriParam : config.xola.url;
